import React from 'react';
import { useState, useEffect } from 'react'; 
import { useParams, useNavigate } from 'react-router-dom'; // Import hooks
import { useTranslation } from 'react-i18next'; // Import useTranslation
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../redux/hooks';

// Redux 
import { setSideBarMenu, setDashboardSection } from '../redux/features/general/navigation'; // Import setDashboardSection

// Utils
import menuItems from '../util/navigation/sidebarMenu/hacker';

// Components 
import NavBar from '../components/general/navBar/NavBar';
import Sidebar from '../components/general/navigation/Sidebar';
import Container from '../components/hacker/Container';
import Settings from '../components/hacker/navigation/Settings'; 
import GroupInfo from '../components/hacker/groups/info/GroupInfo';
import LoadingPopup from '../components/general/popups/LoadingPopup';
import DoctorInfo from '../components/hacker/doctors/info/DoctorInfo';
import Page from '../components/general/containers/Page';
import AuthCode from '../components/hacker/doctors/AuthCode';
import CreateTeamMemberPopup from '../components/hacker/teamMembers/CreateTeamMemberPopup';

const Hacker: React.FC = () => {
  const dispatch = useAppDispatch(); 
  const navigate = useNavigate(); // Add navigate hook
  const { t } = useTranslation(); // Add translation hook
  const { section: currentSectionFromUrl } = useParams<{ section?: string }>(); // Read section from URL

  const isGroupInfoPopupOpened = useAppSelector((state) => state.groupsAccess.isGroupInfoPopupOpened); 
  const isDoctorInfoPopupOpened = useAppSelector((state) => state.doctorsAccess.isDoctorInfoPopupOpened); 
  const isLoadingPopupOpened = useAppSelector((state) => state.navigation.isLoadingPopupOpened); 
  const isDoctorsAccessAuthCodePopupOpened = useAppSelector((state) => state.navigation.isDoctorsAccessAuthCodePopupOpened); 
  const isTeamMemberCreationPopupOpened = useAppSelector((state => state.createTeamMember.isTeamMemberCreationPopupOpened));

  useEffect(() => { 
    dispatch(setSideBarMenu(menuItems)); 
  },[]); 

  // --- START OF FIX ---
  // This useEffect hook synchronizes the component's state with the URL.
  useEffect(() => {
    if (currentSectionFromUrl) {
        // If there's a section in the URL, update Redux to show it.
        dispatch(setDashboardSection(currentSectionFromUrl));
    } else if (menuItems.length > 0) {
        // If the URL is just '/hacker', navigate to the first default section.
        navigate(`/hacker/${menuItems[0].section}`, { replace: true });
    }
  }, [currentSectionFromUrl, dispatch, navigate]);
  // --- END OF FIX ---

  return (
    <Page>
          <NavBar>
            <Settings />
          </NavBar>
          
          <Sidebar />

          <Container />

          {isGroupInfoPopupOpened && <GroupInfo />}
          {isDoctorInfoPopupOpened && <DoctorInfo />}
          {isTeamMemberCreationPopupOpened && <CreateTeamMemberPopup />}
          {isDoctorsAccessAuthCodePopupOpened && <AuthCode />}
          {isLoadingPopupOpened && <LoadingPopup />}
    </Page>
  );
};

export default Hacker;